const Builder = require('./BuilderBase');

module.exports = class SensorReadList extends Builder {
    constructor(title, properties) {
        super('list_SensorReadList', title, properties);
    }
};
